import * as apiWorkSpace from '@/api/workspace';

export default {
    namespaced: true,
    state: {
        workspaces: [],
        isFetching: false,
        workSpaceInviteToken: null
    },
    mutations: {
        SET_WORKSPACE_INVITE_TOKEN(state, payload){
            state.workSpaceInviteToken = payload;
        },
        SET_WORKSPACES(state, payload) {
            state.workspaces.splice(0, state.workspaces.length, ...payload)
            state.isFetching = false;
        },
        LOADING_WORKSPACES(state) {
            state.isFetching = true;
        },
        REPLACE(state, payload){
            let idx = state.workspaces.findIndex((ws) => ws.id === payload.id);
            if(idx !== -1){
                state.workspaces.splice(idx, 1, payload);
            }
        }
    },
    actions: {
        async LOAD_WORKSPACES({ commit, dispatch}){
            try{
                commit('LOADING_WORKSPACES');
                let result = await apiWorkSpace.listWorkspacesForUser();
                dispatch('SET_WORKSPACES', result.data.data);
            }catch(e){
                console.log(e);
                commit('SET_ERROR_MESSAGE', 'Ошибка загрузки рабочего пространства');
                dispatch('CLEAR_WORK_SPACE');
            }
        },
        SET_WORKSPACES({ commit}, payload) {
            commit('SET_WORKSPACES', payload);
        },
        REPLACE({commit}, workspace){
            commit('REPLACE', workspace);
        },
        RESET_INVITE_WORKSPACE({commit}){
            commit('SET_WORKSPACE_INVITE_TOKEN', null);
        },
        SET_INVITE_WORKSPACE({commit}, workspace){
            commit('SET_WORKSPACE_INVITE_TOKEN', workspace.invite_token);
        },
        SET_INVITE_WORKSPACE_BY_ID({getters, dispatch}, workspaceId){
            let ws = getters.GET_WORK_SPACE(workspaceId);
            if(ws === undefined){
                console.log('SET_INVITE_WORKSPACE_BY_ID not found ws ' + workspaceId);
                return Promise.reject();
            }
            return dispatch('SET_INVITE_WORKSPACE', ws);
        }
    },
    getters: {
        IS_PARTICIPANT_WORK_SPACE: (state, getters) => (workspaceId) => {
            let ws = getters.GET_WORK_SPACE(workspaceId);
            return ws.is_participant_work_space === true;
        },
        GET_WORK_SPACE: (state) => (workspaceId) => {
            return state.workspaces.find(workspace => workspace.id === workspaceId);
        },
        LIST_WORKSPACES(state){
            return state.workspaces;
        },
        CURRENT_WORKSPACE(state){
            return state.workspaces.find(workspace => workspace.is_current);
        },
        ID_CURRENT_WORKSPACE(state, getters){
            if(getters.CURRENT_WORKSPACE !== undefined){
                return getters.CURRENT_WORKSPACE.id
            }
            return undefined;
        },
        WORKSPACE_INVITE_TOKEN: state => state.workSpaceInviteToken,
    },
  }